"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCapsLockDetector = void 0;
const react_1 = require("react");
const helpers_1 = require("../../helpers");
function useCapsLockDetector() {
    const capsLockState = (0, helpers_1.useStateValue)(false);
    (0, react_1.useEffect)(() => {
        function capsLockKeyEventHandler(e) {
            var _a;
            const isActive = (_a = e.getModifierState) === null || _a === void 0 ? void 0 : _a.call(e, 'CapsLock');
            if (isActive !== capsLockState.getValue()) {
                capsLockState.setValue(isActive);
            }
        }
        document.addEventListener('keydown', capsLockKeyEventHandler);
        document.addEventListener('keyup', capsLockKeyEventHandler);
        return () => {
            document.removeEventListener('keydown', capsLockKeyEventHandler);
            document.removeEventListener('keyup', capsLockKeyEventHandler);
        };
    }, [capsLockState]);
    return capsLockState.getValue();
}
exports.useCapsLockDetector = useCapsLockDetector;
//# sourceMappingURL=useCapsLockDetector.js.map